// @flow

import ko from 'knockout';
import $ from 'jquery';

function concatAfter (bindingHandlerName, after) {
	const bindingHandler = ko.bindingHandlers[bindingHandlerName];

	bindingHandler.after = bindingHandler.after || [];

	bindingHandler.after = bindingHandler.after.concat(after);
}

concatAfter('click', [ 'enable', 'disable' ]);
concatAfter('event', [ 'enable', 'disable' ]);

function getShouldEnable (valueAccessor) {
	return Boolean(ko.unwrap(valueAccessor()));
}

ko.bindingHandlers.enable = {
	init: function (element, valueAccessor) {
		$(element).on('click.ko.enable', e => {
			const shouldEnable = getShouldEnable(valueAccessor);

			if (shouldEnable) {
				return;
			}

			e.stopImmediatePropagation();
			e.preventDefault();
		});
	},

	update: function (element, valueAccessor) {
		const shouldEnable = getShouldEnable(valueAccessor);

		if (shouldEnable && element.disabled) {
			element.disabled = false;
		} else if ((!shouldEnable) && (!element.disabled)) {
			element.disabled = true;
		}

		if (shouldEnable && element.hasAttribute('disabled')) {
			element.removeAttribute('disabled');
		} else if ((!shouldEnable) && (!element.hasAttribute('disabled'))) {
			element.setAttribute('disabled', '');
		}
	},
};

function negate (valueAccessor) {
	return () => !ko.unwrap(valueAccessor());
}

ko.bindingHandlers.disable = {
	init: function (element, valueAccessor) {
		ko.bindingHandlers.enable.init(element, negate(valueAccessor));
	},

	update: function (element, valueAccessor) {
		ko.bindingHandlers.enable.update(element, negate(valueAccessor));
	},
};
